<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form-model layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="预约时间">
                <a-date-picker
                  v-model="queryParam.agreedTime"
                  placeholder="预约时间"
                  style="width: 100%;"
                />
              </a-form-model-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-model-item label="联系方式"
                ><a-input
                  allowClear
                  v-model="queryParam.telPhone"
                  placeholder="联系方式"
              /></a-form-model-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-model-item label="姓名"
                  ><a-input
                    allowClear
                    v-model="queryParam.custName"
                    placeholder="姓名"
                /></a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="状态">
                  <a-select
                    v-model="queryParam.sta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="R">未处理</a-select-option>
                    <a-select-option value="I">已处理</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button style="margin-left: 8px" @click="reset"
                  >重置</a-button
                >
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form-model>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :scroll="{ x: 1800 }"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
      >
        <span slot="sta" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag
              class="render-tag"
              :color="record.sta == 'R' ? 'grey' : '#87d068'"
              >{{ record.sta == "R" ? "未处理" : "已回复" }}</a-tag
            >
          </template>
        </span>
        <span slot="rentSta" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag
              class="render-tag"
              color="#87d068"
              v-if="record.rentSta == '2'"
              >已出租</a-tag
            >
          </template>
        </span>
        <span slot="isManRender" slot-scope="text">
          <template>
            {{ text == "MAN" ? "先生" : "女士" }}
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a class="a-action" @click="see(record)">查看</a>
          </template>
        </span>
      </s-table>
    </a-card>

    <make-info ref="info" @success="$refs.table.refresh(true)"></make-info>
  </page-view>
</template>
<script>
import { PageView } from "@/layouts";
import { STable } from "@/components";
import moment from "moment";
import MakeInfo from "./MakeInfo.vue";
export default {
  components: {
    PageView,
    STable,
    MakeInfo
  },
  name: "MakeList",
  data() {
    return {
      userInfo: {},
      advanced: false,
      queryParam: {
        sta: "R"
      },
      // 表头
      columns: [
        {
          title: "编号",
          dataIndex: "makeNo",
          scopedSlots: { customRender: "sta" }
        },
        {
          title: "姓名",
          dataIndex: "custName"
        },
        {
          title: "先生/女士",
          dataIndex: "isMan",
          scopedSlots: { customRender: "isManRender" }
        },
        {
          title: "联系方式",
          dataIndex: "telPhone"
        },
        {
          title: "房源名称",
          dataIndex: "houseName",
          scopedSlots: { customRender: "rentSta" }
        },
        {
          title: "预约时间",
          dataIndex: "agreedTime"
        },
        {
          title: "信息描述",
          dataIndex: "intro"
        },
        {
          title: "修改人",
          dataIndex: "modifyUser"
        },
        {
          title: "修改时间",
          dataIndex: "modifyDatetime"
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          fixed: "right",
          width: 100,
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        let param = Object.assign(parameter, this.queryParam);
        if (this.queryParam.agreedTime) {
          param.agreedTime = moment(this.queryParam.agreedTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        }
        return this.$http.roomBksApi.pageHouseMakeRecord(param).then(res => {
          return res.resultObject;
        });
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.queryParam.merchantNo = this.userInfo.merchantNo;
    this.queryParam.userType = this.userInfo.userType;
    this.queryParam.userNo = this.userInfo.userNo;
  },
  methods: {
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    reset() {
      this.queryParam = {};
      this.queryParam.sta = "R";
      this.queryParam.merchantNo = this.userInfo.merchantNo;
      this.queryParam.userType = this.userInfo.userType;
      this.queryParam.userNo = this.userInfo.userNo;
    },
    see(item) {
      this.$refs.info.showModal(item);
    }
  }
};
</script>

<style lang="less" scoped>
.actions {
  button {
    margin-right: 10px;
  }
}
</style>
